import { render, staticRenderFns } from "./AddOnItems.vue?vue&type=template&id=47935a3d&scoped=true&"
import script from "./AddOnItems.vue?vue&type=script&lang=js&"
export * from "./AddOnItems.vue?vue&type=script&lang=js&"
import style0 from "./AddOnItems.vue?vue&type=style&index=0&id=47935a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47935a3d",
  null
  
)

export default component.exports